import { compose, withProps } from 'recompose'
import classnames from 'classnames'
import Icon from './Icon'

import styles from './Icon.module.scss'

const defineIcon = (iconClassName, flipped) => {
  const IconType = compose(
    withProps(props => ({
      className: classnames(
        props.className,
        iconClassName,
        flipped && styles.flipped
      )
    }))
  )(Icon)

  IconType.classNames = [Icon.className, iconClassName]

  return IconType
}

export default defineIcon
